import { translateText } from "../../../helpers/LanguageHelper";
import React from "react";
import { getAppLanguage } from '../../../helpers/LanguageHelper';
import { Row, Col, Container } from "reactstrap";


const SiteBreadcrumb = ({title , parent}) => {

    return (
        <>
          
            <div className="breadcrumb-main ukl-breadcrumb">
                <Container>
                    <Row>
                        <Col>
                            <div className="breadcrumb-contain">
                                <div>
                                    <h2>{translateText(title)}</h2>
                                    <ul>
                                        <li>
                                            <a href={`/${getAppLanguage()}/`}>{translateText(parent)}</a>
                                        </li>
                                        <li>
                                            <i className="fa fa-angle-double-right"></i>
                                        </li>
                                        <li>
                                            <span>{translateText(title)}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );

}

export default SiteBreadcrumb;
